'use strict';


$(document).ready(function () {
    require('./components/spritespin');
});
